import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const AddUpdateClientPrice = ({
  showModal,
  setModalVisible,
  modalAction,
  formData,
  handleSelectChange,
  handleChange,
  handleAddOrUpdateClientPrice,
  allClinicLists,
  pathologyServices,
}) => {
  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="md"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create"
            ? "Add Client Price"
            : "Update Client Price"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        ></button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleAddOrUpdateClientPrice}>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Client:</label>
                <Select
                  name="client"
                  value={
                    formData?.clientId
                      ? {
                          value: formData?.clientId,
                          label: formData?.clientName,
                        }
                      : null
                  }
                  options={allClinicLists?.map((client) => ({
                    value: client?._id,
                    label: client?.userId?.name,
                  }))}
                  onChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "client")
                  }
                />
              </div>
            </div>

            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Test:</label>
                <Select
                  options={pathologyServices?.map((pathologyService) => ({
                    value: pathologyService?._id,
                    label:
                      pathologyService?.profileName ||
                      pathologyService?.testName,
                    type: pathologyService?.testType,
                  }))}
                  onChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "service")
                  }
                  value={
                    formData?.serviceId
                      ? {
                          value: formData?.serviceId,
                          label: formData?.serviceName,
                        }
                      : null
                  }
                  styles={{
                    container: (provided) => ({ ...provided, marginTop: 8 }),
                  }}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label htmlFor="price" className="col-form-label">
                  Price:
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="price"
                  id="price"
                  value={formData.price}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </Button>
            <Button type="submit" className="btn btn-success">
              {modalAction === "create"
                ? "Add ClientPrice"
                : "Update ClientPrice"}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default AddUpdateClientPrice;
